/* eslint-disable no-empty */
import { axiosInstance } from '../initialization';

async function sendConversion(user, apiKey) {
  try {
    const headers = {};
    const dataBody = {
      event_type: 'CONVERSION',
      event_family: 'CDP',
      payload: {
        conversion_identifier: 'Cadastro eShop',
        name: user.name,
        email: user.email,
        ...user.role ? { job_title: user.role } : {},
        state: user.state,
        city: user.city,
        country: user.country,
        ...user.phoneOnlyNumber.length > 10 ? { mobile_phone: user.phone } : { personal_phone: user.phone },
        ...user.companyName ? {
          company_name: user.companyName,
          company_address: user.address,
        } : {},
        tags: ['nortel', 'nortel eshop', `${new Date().getFullYear()}`],
        available_for_mailing: true,
      },
    };

    if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';

    return axiosInstance({
      method: 'post',
      url: `https://api.rd.services/platform/conversions?api_key=${apiKey}`,
      data: dataBody,
      headers,
    });
  } catch (e) { }
}

export default {
  sendConversion,
};
